import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";

import { Container, FormControlLabel, Grid, Switch } from "@material-ui/core";
import { Add, /*DeleteOutlined,*/ EditOutlined } from "@material-ui/icons"; //  DeleteOutiled Comentado por ordens superiores

import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import BigDataTable from "../../../components/tables/BigDataTable";
import {
  VendedoresContext,
  VendedoresContextProvider,
} from "./contexts/VendedoresContext";

import { QueryParamsContext } from "../../../context/QueryParamsContext";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import Btn from "../../../components/buttons/Btn";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
// import useVendedorController from "./controllers/VendedorController"; // Comentado por ordens superiores

import { PainelContainer } from "./styles/Vendedor";
import { TableContent } from "./styles/Vendedor";
import { BallContainer } from "./styles/Vendedor";
import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";
import { findEmpresas } from "../../../repositories/qerpapi/erp/prouser/v1/EmpresasRepository";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const View = () => {
  const { queryParams } = useContext(QueryParamsContext);
  // const { handleDeleteSeller } = useVendedorController(); // Comentado por ordens superiores

  const [showOnlyActives, setShowOnlyActives] = useState(true);
  // const [viewLoading, setViewLoading] = useState(false); // Comentado por ordens superiores
  // eslint-disable-next-line no-unused-vars
  const [reload, setReload] = useState(false);
  const [textFilter, setTextFilter] = useState("");
  const [queryWhere, setQueryWhere] = useState({ ativo: "S" });
  const { loading, listCompanies, setListCompanies, sellerType } =
    useContext(VendedoresContext);
  const [queryOrWhere, setQueryOrWhere] = useState("");
  const { push } = useHistory();

  useEffect(() => {
    setQueryWhere({ ativo: showOnlyActives ? "S" : "N" });
  }, [showOnlyActives]);

  useEffect(() => {
    (async () => {
      const resultCompanies = await findEmpresas(queryParams.empresa_cnpj);
      if (resultCompanies.success) setListCompanies(resultCompanies.data);
    })();
  }, [queryParams.empresa_cnpj, setListCompanies]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlined />,
                name: "Editar",
                action: () => {
                  push(`cadastro`, { item });
                },
              },
              // Comentado por ordens superiores
              // {
              //   icon: <DeleteOutlined />,
              //   name: "Excluir",
              //   action: () =>
              //     handleDeleteSeller(item.id, setViewLoading, setReload),
              // },
            ]}
          />
        );
      },
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "nomevendedor",
      label: "Razão/Nome",
    },
    {
      id: "apelido",
      label: "Fantasia",
    },
    {
      id: "idempresa",
      label: "Empresa",
      format: (item) =>
        listCompanies.find((company) => item.idempresa === company.id)
          ?.apelido ?? "",
    },
    {
      id: "tipo",
      label: "Tipo",
      format: (item) =>
        sellerType.find((type) => item.tipo === type.value)?.label ?? "",
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="Vendedor Ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Vendedor Inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    if (textFilter) {
      clearInterval(typingTimer);
      typingTimer = setTimeout(() => {
        setQueryOrWhere({
          nomevendedor: encodeURIComponent(`${textFilter}`),
          apelido: encodeURIComponent(`${textFilter}`),
          id: `${textFilter.replace(/[^0-9]/g, "") || null}`,
          cpfcnpj: encodeURIComponent(`${textFilter}`),
        });
      }, 1500);
    } else setQueryOrWhere("");
  }, [textFilter]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE VENDEDORES"
        textcolor="black"
        videoId={GlobalVariables.screenVideosIds.cadastroVendedores}
      />

      <PainelContainer />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={12} md={7}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por ID, CPF/CNPJ, Nome ou Apelido"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<Add />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} lg={12}>
            <TableContent>
              <BigDataTable
                tableTitle=""
                route="vendas/vendedores/v1"
                columns={columns}
                where={queryWhere}
                orWhere={queryOrWhere}
                reload={reload}
                include="contasbancarias,empresa"
                filter={{
                  "vendas.vendedores": "nomevendedor,apelido,empresa,ativo",
                }}
              />
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const VendedorListagem = () => (
  <VendedoresContextProvider>
    <View />
  </VendedoresContextProvider>
);

export default VendedorListagem;
